import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const getDomain = () => {
  return {
    type: actionTypes.GET_DOMAIN,
    domain: null
  }
}

export const getName = () => {
  return {
    type: actionTypes.GET_NAME,
    nameSlogan: null
  }
}

export const getPrefaceSuccess = (data) => {
  return {
    type: actionTypes.GET_PREFACE,
    text: data
  }
}

export const getMenuSuccess = (data) => {
  return {
    type: actionTypes.GET_MENU,
    menu: data
  }
}

export const getCarousel = () => {
  return {
    type: actionTypes.GET_CAROUSEL,
    images: null
  }
}

export const getPageSuccess = (data) => {
  return {
    type: actionTypes.GET_PAGE,
    node: data
  }
}

export const getPostListSuccess = (data) => {
  return {
    type: actionTypes.GET_LIST_POSTS,
    list: data
  }
}

export const getLastListSuccess = (data) => {
  return {
    type: actionTypes.GET_LAST_LIST_POSTS,
    lastList: data
  }
}

export const getInterestingLinksSuccess = (data) => {
  return {
    type: actionTypes.GET_INTERESTING_LINKS,
    interestingLinks: data
  }
}

export const getAllPostsSuccess = (data) => {
  return {
    type: actionTypes.GET_ALL_POSTS,
    allPosts: data
  }
}

export const inHome = () => {
  return {
    type: actionTypes.IN_HOME
  }
}

export const noHome = () => {
  return {
    type: actionTypes.NO_HOME
  }
}

export const getMenu = () => {
  return dispatch => {
    axios.get('api/menu_items/main')
      .then(res => {
        const fetchMenu = [];
        for (const key in res.data) {
          fetchMenu.push({
            ...res.data[key],
            id: key
          });
        }
        dispatch(getMenuSuccess(fetchMenu));
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}

export const getPreface = () => {
  return dispatch => {
    axios.get('rest/node/10')
      .then(res => {
        dispatch(getPrefaceSuccess(res.data[0].body));
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}

export const getPage = (id) => {
  return dispatch => {
    axios.get(`rest/node/${id}`)
      .then(res => {
        dispatch(getPageSuccess(res.data[0]));
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}

export const getPostList = () => {
  return dispatch => {
    axios.get(`rest/promote/list`)
      .then(res => {
        dispatch(getPostListSuccess(res.data))
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}

export const getLastPostList = () => {
  return dispatch => {
    axios.get(`rest/last/list`)
      .then(res => {
        dispatch(getLastListSuccess(res.data))
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}

export const getInterestingLinks = () => {
  return dispatch => {
    axios.get('rest/node/13')
      .then(res => {
        dispatch(getInterestingLinksSuccess(res.data[0].body));
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}

export const getAllPosts = () => {
  return dispatch => {
    axios.get('rest/all/list')
      .then(res => {
        dispatch(getAllPostsSuccess(res.data));
      })
      .catch(err => {
        dispatch(console.log(err));
      })
  }
}
